import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
  useLocation,
} from "react-router-dom";

import {connect} from 'react-redux';
import {Actions as PAYMENTACTIONS} from '../store/actions/paymentActions';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import BestPriceCalculator from '../components/common/BestPriceCalculator'
import EasyToFollowPricing from '../components/pricing/EasyToFollowPricing'
import PricingTable from '../components/pricing/PricingTable'
import PricingMonthly from '../components/pricing/BureauPricing'
import PricingFaq from '../components/pricing/PricingFaq'
import Team from '../components/team/Team'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'


import MaltaFlag from '../assets/flags/malta.svg';

import mcDonaldsLogo from '../assets/images/mc-donalds.png';
import sixteenLogo from '../assets/images/sixteen.png';
import myokaLogo from '../assets/images/myoka.png';
import skySpiritLogo from '../assets/images/sky-spirit.png';
import SeoHeaders from "../components/SeoHeaders";

function Pricing({
  getBundles,
  bundles,
  faqs
}) {
  let location = useLocation();

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

  const currencySign = country === 'uk' ? '£' : '€'
  const currency = country === 'uk' ? "GBP" : "EUR"

  useEffect(() => {
    getBundles()
  },[]);

  useEffect(() => {

  },[bundles]);


  return (

    <React.Fragment>
      <SeoHeaders
          title={"Payroll Bureau Software Pricing | Buddy"}
          description={"Payroll Software pricing for service providers, including payroll bureaus, accountants and bookkeepers."}
      />

      <PricingMonthly/>
      <PricingFaq faqs={faqs} currencySign={currencySign}/>

    </React.Fragment>

  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  const faqs = [
    {
      id: 1,
      question: "What's an Active Employee?",
      answer:
        "An active employee is defined as a) a Full Time Employee or b) a Part-Time or Contracted Employee that in a given month has had either of following created: Payslip with a value larger than 0, a timesheet entry or a leave entry.",
    },
    {
      id: 2,
      question: "Why aren't pay as you go fees per payslip?",
      answer:
        "We found that per-payslip pricing was becoming challenging for Service Providers with Weekly payroll, and equally, a number of service providers were never deactivating accounts when there are no payslips issued, with employers still using the platform for holiday management. We needed to find a balance where we get paid for the services we deliver, even if no payslips are issued. Hence given most payroll is run monthly, we identified the monthly active employee as a fair metric.",
    },
    // {
    //   id: 3,
    //   question: "What's the difference between `The Solo Act` and `The Collaborator`?",
    //   answer:
    //     "The solo-act allows your payroll team to work on their own, without asking client to manage holidays, input data or approve payroll. The Collaborator also gives additional features with auotmation, such as EverRoll™ where you can set payrolls on schedule. Keep in mind that you can choose different plans per client, to ensure you get the maximum value out of Buddy.",
    // },
    {
      id: 4,
      question: "What customer support is included?",
      answer:
        "Within all three plans we include system support free of charge via Chat and Email. Payroll knowledge queries are not included in our free support. We provide detailed user-guides filled with payroll specific knowledge, a detailed payroll guide as well as the option to undertake payroll courses. While our payroll solution will try to keep you in safe boundaries, we recommend speaking to a specialist if you need tax or payroll advise.",
    },
    {
      id: 5,
      question: "My client has separately bought a Business plan with Buddy how does it work?",
      answer:
        "If your client paid for plan within Buddy, you may not need to pay separately for Buddy. This depends on the plan which the client paid for and what you are looking to do. If its your first experience with Buddy, reach out to our customer success team so they can guide you through the process.",
    },
    {
      id: 6,
      question: "When will my card be charged?",
      answer:
        "No up-front commitment is required, and you can safely use the demo account to try out Buddy. Once you have employees set up on a live account, an email notification is sent on the 20th of the month, with your card charged on the 24th. If you need any clarification or extension to your demo, reach out to our support.",
    },
    {
      id: 7,
      question: "What if there's a problem charging my card?",
      answer:
        "If there's a problem charging your card, we will notify you via email. We will try to charge your card another 3 times, after which your account will be suspended. If you need any clarification.",
    },
    {
      id: 8,
      question: "Can I pay using a Bank Transfer?",
      answer:
        "Yes, each business is given a unique payment reference, which is used to automatically allocate funds into your account. if there are prepayments/overpayments we will hold these funds on account. You can find this reference in the Billing section of your account. No refunds are processed for prepayments/overpayments.",
    },
    {
      id: 9,
      question: "Can I get help to setup my account?",
      answer:
        `Our team offers training and onboarding assistance, including data migration from other solutions. If you're stuck and need a hand to get going, schedule a time to speak to us. Training and Onboarding costs start from [currency]300 + VAT and may vary based on volume of data transfer required. Kindly note that limited slots are available per month.`,
    },
    {
      id: 10,
      question: "Can I perform payroll retroactively?",
      answer:
        "Yes! If you need to catch-up and get your tax documents in order, you can perform payroll for previous months and years. It should be noted that the month of activity is based on the period in which it is relative to, and not the date in which that action is done. Therefore, retroactive actions may still be charged; such as performing January to December payroll in December will count as 12 months of activity.",
    },
    // More questions...
  ]


  return {
    bundles: state.payment.bundles,
    faqs
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pricing)
